import { useContext } from 'react';
import { SizePreferencesModalContext } from 'sizePreferences/providers/SizePreferencesModalProvider';

export const useSizePreferencesModal = () => useContext(SizePreferencesModalContext);
